<template>
  <div class="container">
    <div class="row justify-content-center">
      <img class="img-fluid d-none d-sm-block" src="/static/img/programme.png" alt="Programme">
      <img class="img-fluid d-block d-sm-none" src="/static/img/programme-min.png" alt="Programme">
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  data () {
    return {
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ProgrammeSection.vue